import React from 'react';
import { styled } from '@glitz/react';
import { Paragraph, ResponsiveSize } from 'Shared/SharedComponents/atoms/Typography';
import { LocationScaled } from 'Shared/Icons/Location';
import { SearchInput, Toggle } from 'Shared/SharedComponents/atoms/InputField';
import * as style from 'Shared/Style';
import Loader from 'SiteLayout/Loader';

type SearchStoresLabels = {
  searchPlaceholder: string;
  searchInStockToggle: string;
};

type PropType = {
  labels: SearchStoresLabels;
  updateResults: (searchString: string) => void;
  setOnlyShowIfInStock: (onlyShowIfInStock: boolean) => void;
  showSpinner: boolean;
  isCompact: boolean;
};

const Wrap = styled.div({
  display: 'flex', 
  flexDirection: 'column', 
  margin: { top: '24px' }, 
  width: '100%',
  ['@media ' + style.mediaMinLarge]: {
    flexDirection: 'row'
  },
})

const SearchInputWrap = styled.div({
  ['@media ' + style.mediaMinLarge]: {
    flex: { basis: '50%' },
    padding: { right: '16px' },
  },
})

const ToggleWrap = styled.div({
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  ['@media ' + style.mediaUpToLarge]: {
    margin: { top: '13px' },
  },
  ['@media ' + style.mediaMinLarge]: {
    flex: { basis: '50%' },
  },
})

const Map = styled(LocationScaled, {
  alignSelf: 'center', 
  width: '24px',
  height: '24px'
})

function SearchStores({ labels, updateResults, setOnlyShowIfInStock, isCompact, showSpinner }: PropType) {
  return (
    <Wrap className="store-availability-modal__search-container">
      <SearchInputWrap>
        <SearchInput
          placeholderText={labels.searchPlaceholder}
          onUpdate={(event) => updateResults(event.currentTarget.value)}
          iconAfter={<Map />}
        />
      </SearchInputWrap>
      <ToggleWrap className="store-availability-modal__find-store">
        <Toggle onChange={setOnlyShowIfInStock} />
        <Paragraph fontSize={ResponsiveSize.D14_M14_L130}>{labels.searchInStockToggle}</Paragraph>
      </ToggleWrap>
      <Loader visible={showSpinner} />
    </Wrap>
  );
}

export default SearchStores;
